<template>
  <div class="categories">
    <CategoriesTreeItem
      :categories="categories"
      :depth="depth"
      :selected-category="selectedCategory"
      @select="handleSelectCategory"
      @click="handleClickCategory"
    >
      <template #default="{ category }">
        {{ category.name }}
      </template>
    </CategoriesTreeItem>
    <component
      :is="$options.name"
      v-if="selectedCategory.hasChildren"
      :key="selectedCategory.id"
      :ref="`category${selectedCategory.id}`"
      :depth="depth + 1"
      :value="selectedCategory"
      class="static"
      @select="handleSelect"
      @back="back"
    />
  </div>
</template>

<script>
import isEmpty from 'es-toolkit/compat/isEmpty'
import CategoriesTreeItem from './categories_tree_item.vue'
export default {
  name: 'CategoriesTree',
  components: {
    CategoriesTreeItem,
  },
  props: {
    depth: {
      type: Number,
      default: 0,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['select', 'back'],
  setup () {
    const searchForm = useSearchForm()
    return {
      city: searchForm.city,
      selectCategory: searchForm.selectCategory,
      hideCategoriesMenu: useGlobal().hideCategoriesMenu,
    }
  },
  data () {
    return {
      hasChildren: false,
      selectedCategory: {},
    }
  },
  computed: {
    categories () {
      let result = []

      if (this.value.id) {
        result = useCategories().getCategoryChildrenById(this.value.id)
      } else {
        result = useCategories().getRootCategories()
      }

      result = result.map(item => {
        const copyItem = { ...item }
        let hasChildrens = false
        copyItem.childrenIds.forEach(element => {
          const a = useCategories().getCategoryById(element)
          if (a?.meta?.isEmpty === false) {
            hasChildrens = true
          }
        })
        copyItem.hasChildren = hasChildrens
        return copyItem
      })
      return result.filter(item => !item.meta.isEmpty)
    },
  },
  methods: {
    handleSelectCategory (category) {
      this.selectedCategory = category
      this.$emit('select', category)
    },
    backCategory () {
      if (!isEmpty(this.selectedCategory)) {
        const refName = `category${this.selectedCategory.id}`
        this.$refs[refName].backCategory()
      } else {
        this.$emit('back')
      }
    },
    back () {
      this.$emit(
        'select',
        useCategories().getCategoryById(this.selectedCategory.ancestorIds[0]),
      )
      this.selectedCategory = {}
    },

    handleSelect (category) {
      if (!isEmpty(category)) {
        this.$emit('select', category)
      }
    },

    handleClickCategory (value) {
      this.handleSelectCategory(value)
      if (value.hasChildren) {
        return
      }
      this.hideCategoriesMenu()
      this.selectCategory(value)
      this.$router.push(this.$localePath(`/${this.city.slug}/catalog/${value.slug}`))
    },
  },
}
</script>

<style lang="sass">
  .categories
    @apply flex flex-row w-full
</style>
